import React from "react";

import { Button, ButtonProps, Group } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconSparkles } from "@tabler/icons-react";

import { UpSellModal } from "components/UpSellButton/UpSellModal";

interface UpSellButtonProps extends Omit<ButtonProps, "children"> {
  children: string | JSX.Element | JSX.Element[];
  withSparkle?: boolean;
}

export function UpSellButton({
  children,
  withSparkle = true,
  ...buttonProps
}: UpSellButtonProps): JSX.Element {
  const [opened, handlers] = useDisclosure(false);
  return (
    <>
      <Button variant="default" onClick={handlers.open} {...buttonProps}>
        <Group wrap="nowrap">
          {withSparkle && <IconSparkles size={16} />}
          {children}
        </Group>
      </Button>
      <UpSellModal opened={opened} toggle={handlers.toggle} />
    </>
  );
}
